import { combineEpics } from 'redux-observable'
import { concat, of, throwError } from 'rxjs'
import { catchError, filter, mergeMap, switchMap } from 'rxjs/operators'
import { isStatusOk } from '@/api/helpers'
import request from '@/api/request'
import { ECommonApiUrl } from '@/api/urls'
import { openModal } from '@/components/composed/Modal/actions'
import type { ISuccessOrderModalOptions } from '@/components/composed/modals/SuccessOrderModal/interfaces'
import type { Epic } from '@/logic/interfaces'
import { requestFailed, requestFinished, requestStarted } from '@/logic/requestStatus/actions'
import { sendFeedback } from './actions'
import { requestStatusName } from './constants'
import type { IFeedbackFormValues, IFeedbackResponse } from './interfaces'

const onFeedbackFormSubmittedDoSendFeedbackRequest: Epic<IFeedbackFormValues, typeof sendFeedback> = action$ =>
  action$.pipe(
    filter(sendFeedback.match),
    switchMap(({ payload }) =>
      concat(
        of(requestStarted({ name: requestStatusName })),
        request<IFeedbackResponse>({
          url: ECommonApiUrl.feedback,
          method: 'POST',
          body: payload,
        }).pipe(
          mergeMap(response => {
            if (isStatusOk(response)) {
              return of(
                requestFinished({ name: requestStatusName }),
                openModal({
                  options: {
                    dialogId: 'SuccessOrderModal',
                  },
                  contentOptions: {
                    titleId: 'feedbackPage.modal.success.title',
                    titleValues: { id: response.data.id },
                    buttons: [
                      {
                        textId: 'feedbackPage.modal.success.close',
                        modifiers: ['green'],
                        className: 'success-order-modal__button',
                      },
                    ],
                    messageId: 'feedbackPage.modal.success.message',
                  } as ISuccessOrderModalOptions,
                }),
              )
            }

            return throwError(response)
          }),
          catchError(() => of(requestFailed({ name: requestStatusName }))),
        ),
      ),
    ),
  )

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (<any>combineEpics)(onFeedbackFormSubmittedDoSendFeedbackRequest)
